import { z } from 'zod';

//deprecated
const accountInfoLocalSchema = z.object({
  accountHolder: z.string(),
  iban: z.string(),
  bankName: z.string(),
});
const accountInfoInternationalSchema = accountInfoLocalSchema.extend({
  swift: z.string(),
});
export const currencyAccountSchema = z.object({
  id: z.string(),
  currencyName: z.string(),
  code: z.string(),
  imgSrc: z.string(),
  symbol: z.string(),
  value: z.number(),
  mainAccountCurrency: z
    .object({
      symbol: z.string(),
      rate: z.number(),
    })
    .optional(),
  accountInfo: z
    .object({
      local: accountInfoLocalSchema,
      international: accountInfoInternationalSchema,
    })
    .optional(),
});
